// Operator-Console-Einstieg — interner Super-Admin (Marc + Sandro).
// Eigener Bereich /operator, getrennt vom Sachbearbeiter-Frontend + Klient-Portal.
//
// Schlichte Zustands-Navigation (wie das Klient-Portal, ohne verschachtelten
// Router): nicht angemeldet → Login; angemeldet → Kanzleien ↔ Detail ↔ Protokoll.

import { useCallback, useEffect, useState } from "react";

import { Loader } from "@/components/Loader";

import { AuditPage } from "./AuditPage";
import { FirmDetailPage } from "./FirmDetailPage";
import { FirmsPage } from "./FirmsPage";
import { OperatorLoginPage } from "./OperatorLoginPage";
import { clearOperatorSession, getOperatorSession } from "./session";

import "./operator.css";

export function OperatorApp() {
  const [authed, setAuthed] = useState<boolean | null>(null);
  const [view, setView] = useState<"firms" | "audit">("firms");
  const [selectedFirm, setSelectedFirm] = useState<string | null>(null);

  useEffect(() => {
    // Session vorhanden? → als angemeldet behandeln. Abgelaufene Tokens fängt
    // der erste API-Call ab (401 → Refresh, sonst Logout).
    setAuthed(getOperatorSession() !== null);
  }, []);

  const logout = useCallback(() => {
    clearOperatorSession();
    setSelectedFirm(null);
    setView("firms");
    setAuthed(false);
  }, []);

  function go(target: "firms" | "audit") {
    setSelectedFirm(null);
    setView(target);
  }

  if (authed === null) {
    return (
      <div className="op-shell op-center">
        <Loader label="…" />
      </div>
    );
  }

  if (!authed) {
    return <OperatorLoginPage onLogin={() => setAuthed(true)} />;
  }

  return (
    <div className="op-shell">
      <header className="op-header">
        <div className="op-brand">
          Fidena <span className="op-brand-tag">Operator</span>
        </div>
        <nav className="op-nav">
          <button
            type="button"
            className={`op-nav-link${
              view === "firms" && !selectedFirm ? " op-nav-active" : ""
            }`}
            onClick={() => go("firms")}
          >
            Kanzleien
          </button>
          <button
            type="button"
            className={`op-nav-link${
              view === "audit" ? " op-nav-active" : ""
            }`}
            onClick={() => go("audit")}
          >
            Protokoll
          </button>
        </nav>
        <button type="button" className="op-logout" onClick={logout}>
          Abmelden
        </button>
      </header>
      <main className="op-main">
        {selectedFirm ? (
          <FirmDetailPage
            firmId={selectedFirm}
            onBack={() => setSelectedFirm(null)}
            onExpired={logout}
          />
        ) : view === "audit" ? (
          <AuditPage onExpired={logout} />
        ) : (
          <FirmsPage onSelect={setSelectedFirm} onExpired={logout} />
        )}
      </main>
    </div>
  );
}
